//RadarChart.vue



<script>

//Import
import { defineComponent } from 'vue';
import { Radar } from 'vue3-chart-v2';
import * as RadarData from "../classes/RadarData.js";

var buildingResults = [];
var normalizeFactor; 


export default defineComponent({
	name: 'RadarChart',
	data() {
		return {
			chartData: {
				labels: ['Carbon', 'Costs', 'Weight', 'Floor Height', 'Ceiling Height'],
				datasets: [
				], 
			},
			options: {
				legend: {
					// display: false,
					position: 'bottom',
					maxHeight: 2,
					maxWidth: 20,
					align: 'center',
					fullSize: false,
					labels: {
						fontSize: 12,
						boxWidth: 12,
						usePointStyle: true
					}
				},
				element: {
					line: {
						tension: 20,
						borderWidth: 6
					}
				},
				scale: {
					ticks: {
					beginAtZero: true,
						fontColor: 'transparent',	//Labels such as 10, 20, etc
						showLabelBackdrop: false	//Hide square behind text
					}
				}
			}

		}
	},
	// props: {
	// 	carbonDataChart: Object
	// },
	extends: Radar,
	methods: {
		scaleChartData() {

			buildingResults = this.$store.state.buildingResults; 
			console.log('buildingResults from radar');
			console.log(buildingResults);
			
			var carbonArray = [];
			var costArray = [];
			var weightArray = [];
			var clearFloorHeightArray = [];
			var structCeilingHeightArray = [];
			// var recycleArray = [];

			for (let i = 0; i < buildingResults.length; i++) {
				carbonArray.push(buildingResults[i].carbonData);
				costArray.push(buildingResults[i].cost);
				weightArray.push(buildingResults[i].weight);
				clearFloorHeightArray.push(buildingResults[i].clearFloorHeight);
				structCeilingHeightArray.push( parseFloat( buildingResults[i].structCeilingHeight) );			
				// resultArray.recycleArray.push(buildingResults[i].recycle);
			}

			var resultArray = [carbonArray, costArray, weightArray, clearFloorHeightArray, structCeilingHeightArray];

			// console.log('resultArray');
			// console.log(resultArray);

			var normArr = []; 

			for (let i = 0; i < resultArray.length; i++) {
				var min = Math.min(...resultArray[i]);
				var max = Math.max(...resultArray[i]);
				var diff = max - min; 

				// console.log('min: ' + min + ', max: ' + max +', diff: ' + diff);

				normArr.push(min);
				normArr.push(diff);
			}

			var normFactor = {
				carbon: {
					minValue: 	normArr[0],
					difference: normArr[1]
				},
				cost: {
					minValue:	normArr[2],
					difference: normArr[3]
				},
				weight: {
					minValue:	normArr[4],
					difference: normArr[5]
				},
				clearFloorHeight: {
					minValue:	normArr[6],
					difference:	normArr[7]
				},
				structCeilingHeight: {
					minValue:	normArr[8],
					difference: normArr[9]
				}
			};

			normalizeFactor = normFactor; 

			// console.log('normFactor');
			// console.log(normFactor);
		},

		setDataSet(buildingResults) {
	
			var dataSets = [];

			for (let i = 0; i < buildingResults.length; i++) {
				var dataSet = new RadarData.DataSet(); 
				dataSet.label = "Variant " +  (i + 1).toString();
				dataSet.borderColor = RadarData.colors[i];
				dataSet.backgroundColor= RadarData.transparentColors[i],
				dataSet.borderCapStyle = "round" ;
				dataSet.borderJoinStyle = "round" ;
				dataSet.fill = true ;

				//Order: Carbon, Cost, Weight, ClearFloorHeight, StructCeilingHeight;
				// dataSet.data = [Math.floor(Math.random() * 100), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100), Math.floor(Math.random() * 100)];
				dataSet.data = [	( 100 - ( ( buildingResults[i].carbonData - 			normalizeFactor.carbon.minValue ) 				/   normalizeFactor.carbon.difference )					* 100 ).toFixed(1),
									( 100 - ( ( buildingResults[i].cost -					normalizeFactor.cost.minValue ) 				/   normalizeFactor.cost.difference )					* 100 ).toFixed(1),
									( 100 -	( ( buildingResults[i].weight -					normalizeFactor.weight.minValue ) 				/   normalizeFactor.weight.difference )					* 100 ).toFixed(1),	
									( 		( ( buildingResults[i].clearFloorHeight - 		normalizeFactor.clearFloorHeight.minValue ) 	/   normalizeFactor.clearFloorHeight.difference )		* 100 ).toFixed(1),					
									( 100 -	( ( buildingResults[i].structCeilingHeight -	normalizeFactor.structCeilingHeight.minValue ) 	/   normalizeFactor.structCeilingHeight.difference )	* 100 ).toFixed(1)
				];

				dataSets.push(dataSet);

				// console.log('dataSet');
				// console.log(dataSet);				
			}

			this.chartData.datasets = dataSets;	

			// console.log('dataSets');
			// console.log(dataSets);
		},
	},
	mounted () {
		this.scaleChartData();
		this.setDataSet(buildingResults);
		this.renderChart(this.chartData, this.options);
  },
})

</script>